const translations = {
  en: {
    // ── Navbar ──────────────────────────────────────────────
    nav: {
      home:       'Home',
      about:      'About',
      products:   'Products',
      order:      'Order',
      orderNow:   'Order Now',
      available:  '24/7 Available',
    },

    // ── Hero ────────────────────────────────────────────────
    hero: {
      badge:       'Trusted Pharmacy Since 2010',
      line1:       'Your Health,',
      line2:       'Delivered',
      line3:       'to Your Door',
      sub:         'Order prescription medicines, OTC drugs, vitamins, and wellness products from our licensed pharmacy. Fast dispatch, cold-chain compliant, and 100% authentic.',
      pill1:       'Licensed & Verified',
      pill2:       'Cold-Chain Delivery',
      pill3:       'Pharmacist Support',
      pill4:       'ISO Certified',
      cta1:        'Place Your Order',
      cta2:        'Browse Products',
      stat1n:      '50,000+',  stat1l: 'Patients Served',
      stat2n:      '99.8%',    stat2l: 'Dispensing Accuracy',
      stat3n:      '2-Hour',   stat3l: 'Express Delivery',
      stat4n:      '24/7',     stat4l: 'Pharmacist On Call',
      cardStatus:  'Processing Orders',
      cardRxTitle: 'Prescription Fulfillment',
      cardRxDesc:  'Upload prescription & we\'ll dispense, verify and deliver.',
      float1t:     'Express Delivery',   float1s: 'Within 2 hours',
      float2t:     '100% Authentic',     float2s: 'Lab-verified medicines',
      float3t:     '2,000+ Products',    float3s: 'In stock, ready to ship',
    },

    // ── About ───────────────────────────────────────────────
    about: {
      stripItems:  ['Licensed Pharmacy','GDP Certified','ISO 9001:2015','HIPAA Compliant','24/7 Pharmacist','Cold-Chain Delivery','Authentic Medicines','Nationwide Shipping'],
      sectionLabel:'About MediCare Pharmacy',
      heading1:    'Caring for Your Health',
      heading2:    'For Over 14 Years',
      headingSub:  'MediCare is a fully licensed, GDP-certified pharmacy committed to providing authentic medications and exceptional patient care — online and in-store.',
      body1:       'Founded in 2010 by a team of clinical pharmacists, MediCare was built on one principle: every patient deserves safe, authentic medicine delivered with dignity. What began as a single community pharmacy has grown into a trusted healthcare partner for over 50,000 patients across the country.',
      body2:       'Our team of 80+ licensed pharmacists, pharmacy technicians, and healthcare professionals work around the clock to ensure every prescription is verified, every medicine is authentic, and every delivery is timely and compliant.',
      cert1:       'Good Distribution Practice',
      cert2:       '9001:2015 Certified',
      cert3:       'Licensed Dispensary',
      cert4:       'Good Manufacturing Practice',
      journeyTitle:'Our Journey',
      milestones:  [
        { year: '2010', event: 'Founded as a neighborhood pharmacy in the city center' },
        { year: '2015', event: 'Expanded to 5 branches across the region' },
        { year: '2019', event: 'Launched online ordering & home delivery service' },
        { year: '2022', event: 'Crossed 50,000 patients served milestone' },
        { year: '2024', event: 'Received ISO 9001 & GDP certification' },
      ],
      servicesTitle: 'What We Offer',
      services: [
        { icon:'💊', title:'Prescription Dispensing',   desc:'Licensed pharmacists verify and dispense all prescriptions with full accuracy checks.' },
        { icon:'🧪', title:'Lab-Tested Medicines',      desc:'Every product batch is tested for authenticity, potency and purity before stocking.' },
        { icon:'❄️', title:'Cold-Chain Logistics',       desc:'Temperature-sensitive medications transported in certified cold-chain packaging.' },
        { icon:'👨‍⚕️', title:'Pharmacist Consultation', desc:'Speak to our licensed pharmacists 24/7 for drug interaction checks and advice.' },
        { icon:'🚚', title:'Express Home Delivery',      desc:'Same-day and 2-hour express delivery options for urgent medication needs.' },
        { icon:'🔒', title:'Patient Confidentiality',   desc:'All orders and medical data handled with strict HIPAA-compliant privacy standards.' },
      ],
      quote:       'Dispensing medicines is a sacred responsibility. Every pill we hand out carries the weight of someone\'s health. We never take that lightly.',
      quoteAuthor: '— Dr. Sarah Ahmed, Chief Pharmacist, MediCare',
    },

    // ── Products ────────────────────────────────────────────
    products: {
      tag:          'Our Pharmacy Catalog',
      heading1:     'Medicines &',
      heading2:     'Wellness',
      heading3:     'Products',
      desc:         'Browse our complete range of prescription medications, OTC drugs, vitamins, and healthcare essentials — all 100% authentic and in-stock.',
      stockBadge:   '2,000+ products in stock',
      filterAll:    'All',
      perUnit:      '/unit',
      orderBtn:     'Order',
      ctaTitle:     'Need a specific medication?',
      ctaSub:       'Upload your prescription and our pharmacist will fulfil it within hours.',
      ctaBtn:       'Place Order Now →',
    },

    // ── Order Section ───────────────────────────────────────
    orderSection: {
      tag:          'Order Your Medicines',
      heading1:     'Secure Online',
      heading2:     'Pharmacy Order',
      sub:          'Fill in the 4-step form below. Our team will review your order, verify payment, and start the dispatch process after that.',
      trust: [
        { icon:'🔒', title:'Payment Info',        desc:'ICBC, Alipay or western union remittance not valid now.' },
        { icon:'✅', title:'For Acceptance',       desc:'Remittance only TT / Cable / wire transfer by Bank to Company account in India is acceptable now.' },
        { icon:'📦', title:'Shipment',             desc:'We dispatch within 2 working days after payment. Delivery to China typically takes 15–30 days, including customs clearance (3–7 days) and EMS/RAM shipping (7–14 days).' },
        { icon:'✉️', title:'Bank Charges',         desc:'Buyer must cover bank charges in China and the USA (intermediary bank). If unknown, add USD 27.00. Subject to final receipt.' },
        { icon:'❄️', title:'Custom-Clearance',     desc:'Only Buyer is responsible for destination custom clearance.' },
        { icon:'🆘', title:'24/7 Help Support',    desc:'Help available around the clock' },
      ],
      rxNotice:     'Upload a photo of your payment proof in the Payment step of the form below. Our Team will verify it before dispensing.',
      footerPhone:  '📞 +91 76-1002-1002',
      footerEmail:  '✉️ info1@cyno.co.in',
      footerHours:  '🕐 Open 24/7',
      footerCopy:   '© 2024 Cyno Medicaments',
      footerPrivacy:'Privacy Policy',
      footerTerms:  'Terms of Service',
      disclaimer:   '⚠️ Cyno Medicaments is a licensed pharmaceutical establishment. All prescription medicines require a valid prescription from a registered medical practitioner.',
    },

    // ── Order Form ──────────────────────────────────────────
    form: {
      steps: [
        { label:'Patient',   icon:'◎', title:'Personal Information', sub:'Your name, email and contact number' },
        { label:'Medicines', icon:'⊞', title:'Select Medicines',     sub:'Choose products from our catalog' },
        { label:'Payment',   icon:'⬡', title:'Payment',              sub:'ICBC, Alipay or western union remittance not valid now.' },
        { label:'Delivery',  icon:'◈', title:'Shipping Address',     sub:'We dispatch within 2 working days after payment. Delivery to China typically takes 15–30 days, including customs clearance (3–7 days) and EMS/RAM shipping (7–14 days).' },
      ],
      fullName:         'Full Name',
      fullNamePh:       'Customer Full Name',
      email:            'Email Address',
      emailPh:          'your@email.com',
      contact:          'Contact Number',
      contactPh:        '+880 1700-000000',
      contactHint:      'Include country code e.g. +880',
      addProduct:       'Add a Medicine / Product',
      selectPh:         '— Search & add medicine or product —',
      product:          'Product',
      qty:              'Qty',
      unitPrice:        'Unit Price',
      subtotal:         'Subtotal',
      noProducts:       'No medicines available. Please check back later.',
      noSelected:       'No medicines selected yet',
      noSelectedHint:   'Search and add medicines from the dropdown above',
      totalLabel:       'TOTAL',
      bankTitle:        'Bank Transfer Details',
      bankSecure:       'Remittance only TT / Cable / wire transfer by Bank to Company account in India is acceptable now.',
      pay:              'Pay:',
      bankFields:       ['Bank', 'Account Holder', 'Account No.', 'Company Address', 'SWIFT Code', 'Bank Branch'],
      uploadLabel:      'Upload Payment Proof',
      uploadHint:       'Please upload a copy or screenshot of the bank deposit receipt with details in both English and Chinese (English is mandatory).',
      uploadRequired:   'Please upload your payment proof to continue',
      uploadCta:        'Drag & drop or click to upload payment proof',
      uploadSub:        'Payment receipt screenshot file · JPG/PNG/PDF · Max 5MB',
      remitterName:     'Remitter Name',
      remitterPh:       'Name of the person sending payment',
      recipientName:    'Consignee Name',
      recipientPh:      'Full name of the recipient',
      sex:              'Sex',
      sexPh:            'Male / Female',
      age:              'Age',
      agePh:            'e.g. 35',
      deliveryPhone:    'Phone',
      deliveryPhonePh:  '+86 000-0000-0000',
      street:           'Address',
      streetPh:         '123 Main Road, Flat 4B',
      apt:              'Apartment / Floor / Building',
      aptPh:            'Apt, Floor, Building name (optional)',
      city:             'City',
      cityPh:           'e.g. Guangzhou',
      state:            'Province',
      statePh:          'e.g. Guangdong',
      postal:           'PIN / ZIP / Postal Code',
      postalPh:         'e.g. 510000',
      country:          'Country',
      countryPh:        '— Select country —',
      orderSummary:     'Order Summary',
      grandTotal:       'Grand Total',
      back:             '← Back',
      continue:         'Continue →',
      placeOrder:       '🚀 Place Order',
      placing:          'Placing Order…',
      required:         '*',
      successTitle:     'Order Received! 💊',
      successSub1:      'A confirmation has been emailed to',
      successSub2:      '!',
      orderId:          'Order ID',
      total:            'Total',
      status:           'Status',
      statusVal:        'Order Under Review',
      newOrder:         'New Order',
    },
  },

  // ════════════════════════════════════════════════════════
  zh: {
    nav: {
      home:       '首页',
      about:      '关于我们',
      products:   '产品',
      order:      '下订单',
      orderNow:   '立即下单',
      available:  '24小时服务',
    },

    hero: {
      badge:       '自2010年以来值得信赖的药房',
      line1:       '您的健康，',
      line2:       '送货上门',
      line3:       '贴心服务',
      sub:         '向我们持牌药房订购处方药、非处方药、维生素及保健产品。快速发货、冷链合规、100%正品。',
      pill1:       '持牌认证',
      pill2:       '冷链配送',
      pill3:       '药剂师支持',
      pill4:       'ISO认证',
      cta1:        '立即下单',
      cta2:        '浏览产品',
      stat1n:      '50,000+',  stat1l: '服务患者',
      stat2n:      '99.8%',    stat2l: '配药准确率',
      stat3n:      '2小时',    stat3l: '快递配送',
      stat4n:      '24/7',     stat4l: '随时候诊',
      cardStatus:  '正在处理订单',
      cardRxTitle: '处方配药服务',
      cardRxDesc:  '上传处方，我们将为您配药、核实并配送。',
      float1t:     '快速配送',     float1s: '2小时内送达',
      float2t:     '100%正品',    float2s: '实验室认证药品',
      float3t:     '2,000+产品',  float3s: '现货，随时发货',
    },

    about: {
      stripItems:  ['持牌药房','GDP认证','ISO 9001:2015','HIPAA合规','24小时药剂师','冷链配送','正品药品','全国配送'],
      sectionLabel:'关于美迪凯尔药房',
      heading1:    '守护您的健康',
      heading2:    '已超过14年',
      headingSub:  '美迪凯尔是一家持全面执照的GDP认证药房，致力于提供正品药物和卓越的患者护理服务——无论在线上还是线下门店。',
      body1:       '美迪凯尔由一支临床药剂师团队于2010年创立，秉承一个原则：每位患者都应获得安全、正品的药物，并受到尊重的对待。从最初的社区药房起步，如今已成为全国超过50,000名患者信赖的医疗健康伙伴。',
      body2:       '我们拥有80余名持牌药剂师、药房技术人员和医疗专业人士，全天候工作，确保每张处方均经核实、每种药物均为正品、每次配送均及时合规。',
      cert1:       '良好分销规范',
      cert2:       '9001:2015认证',
      cert3:       '持牌药房',
      cert4:       '良好生产规范',
      journeyTitle:'我们的发展历程',
      milestones:  [
        { year: '2010', event: '在市中心创立社区药房' },
        { year: '2015', event: '在全国各地扩展至5家分店' },
        { year: '2019', event: '推出在线订购及送货上门服务' },
        { year: '2022', event: '累计服务患者突破50,000人次' },
        { year: '2024', event: '获得ISO 9001及GDP认证' },
      ],
      servicesTitle: '我们的服务',
      services: [
        { icon:'💊', title:'处方配药',       desc:'持牌药剂师对所有处方进行全面准确性核查和配药。' },
        { icon:'🧪', title:'实验室检测药品', desc:'每批产品在上架前均经过真实性、效力和纯度检测。' },
        { icon:'❄️', title:'冷链物流',        desc:'温度敏感型药物采用认证冷链包装运输。' },
        { icon:'👨‍⚕️', title:'药剂师咨询',   desc:'24小时咨询我们的持牌药剂师，进行药物相互作用检查和建议。' },
        { icon:'🚚', title:'快递送货上门',   desc:'提供当日及2小时快递配送选项，满足紧急用药需求。' },
        { icon:'🔒', title:'患者隐私保护',   desc:'所有订单和医疗数据均按照严格的HIPAA合规隐私标准处理。' },
      ],
      quote:       '配发药品是一项神圣的责任。我们递出的每一粒药片，都承载着某人的健康。我们从不轻视这份责任。',
      quoteAuthor: '—— 首席药剂师 Sarah Ahmed 博士，美迪凯尔药房',
    },

    products: {
      tag:          '我们的药房目录',
      heading1:     '药品与',
      heading2:     '健康',
      heading3:     '产品',
      desc:         '浏览我们完整的处方药、非处方药、维生素和医疗保健必需品——所有产品均100%正品且现货供应。',
      stockBadge:   '2,000+产品现货',
      filterAll:    '全部',
      perUnit:      '/单位',
      orderBtn:     '下单',
      ctaTitle:     '需要特定药物？',
      ctaSub:       '上传您的处方，我们的药剂师将在数小时内为您配药。',
      ctaBtn:       '立即下单 →',
    },

    orderSection: {
      tag:          '订购您的药品',
      heading1:     '安全在线',
      heading2:     '药房订单',
      sub:          '请填写以下4步表格。我们的团队将审核您的订单、核实付款，并在此后启动发货流程。',
      trust: [
        { icon:'🔒', title:'付款须知',       desc:'现在不接受工商银行、支付宝或西联汇款。' },
        { icon:'✅', title:'可接受方式',     desc:'现在只接受通过银行电汇（TT/Cable/Wire）汇款到印度公司账户。' },
        { icon:'📦', title:'发货',           desc:'付款后2个工作日内发货。发货到中国通常需要15-30天，包括清关（3-7天）和EMS/RAM运输（7-14天）。' },
        { icon:'✉️', title:'银行手续费',     desc:'买方须承担中国和美国（中间行）的银行手续费。如不确定，请加收27美元，以实际收款为准。' },
        { icon:'❄️', title:'目的地清关',     desc:'目的地清关由买方负责。' },
        { icon:'🆘', title:'24小时客服支持', desc:'全天候提供帮助' },
      ],
      rxNotice:     '请在下方表格的付款步骤中上传银行汇款凭证照片，我们的团队将在发货前进行核实。',
      footerPhone:  '📞 +880 1800-CYNO',
      footerEmail:  '✉️ orders@medicare-pharmacy.com',
      footerHours:  '🕐 全天候营业',
      footerCopy:   '© 2024 Cyno Pharmacy',
      footerPrivacy:'隐私政策',
      footerTerms:  '服务条款',
      disclaimer:   '⚠️ Cyno Pharmacy是一家持牌制药机构。所有处方药均需持有注册执业医师开具的有效处方。',
    },

    form: {
      steps: [
        { label:'患者信息', icon:'◎', title:'个人信息',   sub:'您的姓名、电子邮件及联系电话' },
        { label:'药品选择', icon:'⊞', title:'选择药品',   sub:'从我们的目录中选择产品' },
        { label:'付款方式', icon:'⬡', title:'付款',       sub:'现在不接受工商银行、支付宝或西联汇款。' },
        { label:'配送地址', icon:'◈', title:'收货地址',   sub:'付款后2个工作日内发货，发货到中国通常需要15-30天，包括清关（3-7天）和EMS/RAM运输（7-14天）。' },
      ],
      fullName:         '姓名',
      fullNamePh:       '客户全名',
      email:            '电子邮件地址',
      emailPh:          '您的邮箱@example.com',
      contact:          '联系电话',
      contactPh:        '+86 000-0000-0000',
      contactHint:      '请加国家区号，如 +86',
      addProduct:       '添加药品/产品',
      selectPh:         '— 搜索并添加药品或产品 —',
      product:          '产品',
      qty:              '数量',
      unitPrice:        '单价',
      subtotal:         '小计',
      noProducts:       '暂无药品。请稍后再查。',
      noSelected:       '尚未选择任何药品',
      noSelectedHint:   '请使用上方下拉菜单搜索并添加药品',
      totalLabel:       '合计',
      bankTitle:        '银行转账详情',
      bankSecure:       '现在只接受通过银行电汇（TT/Cable/Wire）汇款到印度公司账户。',
      pay:              '付款金额：',
      bankFields:       ['银行名称', '账户持有人', '账户号码', '公司地址', 'SWIFT代码', '银行支行'],
      uploadLabel:      '上传付款凭证',
      uploadHint:       '请上传银行存款凭证的副本或截图，须同时包含中英文信息（英文为必填）。',
      uploadRequired:   '请上传付款凭证以继续',
      uploadCta:        '拖放或点击上传付款凭证',
      uploadSub:        '付款收据截图 · JPG/PNG/PDF · 最大5MB',
      remitterName:     '汇款人姓名',
      remitterPh:       '付款人姓名',
      recipientName:    '收货人姓名',
      recipientPh:      '收货人全名',
      sex:              '性别',
      sexPh:            '男 / 女',
      age:              '年龄',
      agePh:            '例如：35',
      deliveryPhone:    '联系电话',
      deliveryPhonePh:  '+86 000-0000-0000',
      street:           '地址',
      streetPh:         '街道门牌号',
      apt:              '公寓/楼层/楼名',
      aptPh:            '公寓、楼层、楼名（选填）',
      city:             '城市',
      cityPh:           '例如：广州',
      state:            '省份',
      statePh:          '例如：广东省',
      postal:           '邮政编码 / PIN / ZIP',
      postalPh:         '例如：510000',
      country:          '国家/地区',
      countryPh:        '— 请选择国家 —',
      orderSummary:     '订单摘要',
      grandTotal:       '总计',
      back:             '← 返回',
      continue:         '继续 →',
      placeOrder:       '🚀 提交订单',
      placing:          '正在提交…',
      required:         '*',
      successTitle:     '订单已收到！💊',
      successSub1:      '确认邮件已发送至',
      successSub2:      '！',
      orderId:          '订单编号',
      total:            '总计',
      status:           '状态',
      statusVal:        '订单审核中',
      newOrder:         '新订单',
    },
  },
};

export default translations;